import { StyleSheet } from 'aphrodite';
import { header, inputBorderColor } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		background: '#fff',
		position: 'relative',
	},
	field: {
		background: '#F9F9F9',
		border: `1px solid ${inputBorderColor}`,
		borderRadius: 3,
		color: '#4A4A4A',
		marginTop: 0,
		minWidth: 280,
	},
	fieldContainer: {
		':not(:first-child)': {
			marginTop: 10,
		},
	},
	fields: {
		marginBottom: 20,
		marginRight: 15,
		marginTop: 20,
	},
	label: {
		color: header,
	},
	title: {
		color: header,
		fontSize: 14,
		textTransform: 'uppercase',
	},
	visibility: {
		marginBottom: 20,
		textAlign: 'left',
	},
	visibilityRadioButton: {
		':not(:first-child)': {
			marginTop: 10,
		},
		fontSize: 12,
	},
});
